var productFilter = {};

(function (productFilterApp) {
	var filterModel = {
		Category: null,
		Page: 1
	};
	var fromPopState = false;
	var blockPopstateEvent = true;
	var browserSupportsHistoryApi = window.history && 'pushState' in window.history;

	if (browserSupportsHistoryApi) {
		// prevent Chrome from calling onpopstate on initial load
		$(window).on('load', function () {
			// The timeout ensures that popstate-events will be unblocked right
			// after the load event occured, but not in the same event-loop cycle.
			setTimeout(function () { blockPopstateEvent = false; }, 0);
		});

		$(window).on('popstate', function () {
			if (blockPopstateEvent && document.readyState === "complete") {
				return;
			}
			fromPopState = true;
			performSearchFromUrl();
		});
	}

	function pushHistory() {
		if (browserSupportsHistoryApi && !fromPopState) {
			var currentPath = window.location.pathname;
			var query = "?";
			var queryArray = [];
			if (filterModel.Category) {
				queryArray.push("category=" + filterModel.Category);
			}
			if (filterModel.Page) {
				queryArray.push("page=" + filterModel.Page);
			}
			query += queryArray.join("&");
			history.pushState(null, null, currentPath + query);
		}
		fromPopState = false;
	}

	function performSearchFromUrl() {
		filterModel.Category = null;
		filterModel.Page = 1;
		if (window.location.search.length > 1) {
			for (var aItKey, nKeyId = 0, aCouples = window.location.search.substr(1).split("&");
				nKeyId < aCouples.length;
				nKeyId++) {
				aItKey = aCouples[nKeyId].split("=");
				if (aItKey.length <= 1)
					continue;
				var key = decodeURIComponent(aItKey[0]).toLowerCase();
				var val = decodeURIComponent(aItKey[1]);

				if (key === "category") {
					filterModel.Category = val;
				} else if (key === "page") {
					filterModel.Page = val;
				}
			}
		}
		productFilter.GetProducts();
	}

	function setSubcategoryLinkActive() {
		$(".js-subcategory-link").removeClass("is-active");
		$('.js-subcategory-link[data-subcategory="' + filterModel.Category + '"]').addClass('is-active');
	}

	productFilterApp.GetProducts = function () {
		$.ajax({
			url: "/umbraco/surface/GransremedyProductSurface/GetFilterResult",
			type: "GET",
			data: filterModel,
			dataType: "html",
			success: function (data) {
				$(".js-product-filter-results").html(data);
				pushHistory();
				setSubcategoryLinkActive();

				if ($(".category-menu__container").prop('scrollWidth') > $(".category-menu__container").width()) {
					$(".category-menu__nav-button").show();
				} else {
					$(".category-menu__nav-button").hide();
				}
			},
			error: function (xhr, status, error) {
				console.log(status);
				console.log(xhr.status + " - " + error);
			}
		});
	};

	$(document).ready(function () {
		//Get url params on load
		const urlParams = new URLSearchParams(window.location.search);

		//check if querystring params exist on load/reload
		if (urlParams.get('category'))
			filterModel.Category = urlParams.get('category');

		if (urlParams.get('page'))
			filterModel.Page = urlParams.get('page');


		//on dropdown change events
		$(document).on("click", ".js-subcategory-link", function (e) {
			e.preventDefault();
			filterModel.Category = $(this).data("subcategory");
			filterModel.Page = 1;
			productFilter.GetProducts();
		});


		// pagination
		$(document).on('click', 'div.pagination a', function (e) {
			e.preventDefault();
			filterModel.Page = $(this).data('page');
			productFilter.GetProducts();
			paginationScrollToTop();
		});

		function paginationScrollToTop() {
			$('html, body').animate({
				scrollTop: $(".js-subcategory-results").offset().top - $("header").outerHeight()
			}, 400);
		}
	});

})(productFilter);
